import React from 'react';
import { getEventIcon } from './utils';
import { Block, FlexRow, Title } from '../content';
const AgendaEventField = _ref => {
  var _event$user, _event$visitatore, _event$resources, _event$resources$;
  let {
    event,
    descriptions
  } = _ref;
  return /*#__PURE__*/React.createElement(FlexRow, {
    margin: 0,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(FlexRow, {
    xs: 12,
    lg: 11,
    margin: 0
  }, /*#__PURE__*/React.createElement(Title, {
    xs: 12,
    lg: 4,
    md: 4,
    margin: 0,
    title: event.name,
    description: descriptions.eventName
  }), /*#__PURE__*/React.createElement(Title, {
    xs: 12,
    lg: 4,
    md: 4,
    margin: 0,
    title: ((_event$user = event.user) === null || _event$user === void 0 ? void 0 : _event$user.email) || (event === null || event === void 0 ? void 0 : (_event$visitatore = event.visitatore) === null || _event$visitatore === void 0 ? void 0 : _event$visitatore.email) || event.email,
    description: descriptions.email
  }), /*#__PURE__*/React.createElement(Title, {
    xs: 12,
    lg: 4,
    md: 4,
    margin: 0,
    title: event === null || event === void 0 ? void 0 : (_event$resources = event.resources) === null || _event$resources === void 0 ? void 0 : (_event$resources$ = _event$resources[0]) === null || _event$resources$ === void 0 ? void 0 : _event$resources$.name,
    description: descriptions.resource
  })), /*#__PURE__*/React.createElement(Block, {
    xs: 0,
    lg: 1,
    margin: 0,
    textAlign: "right"
  }, getEventIcon(event)));
};
export default AgendaEventField;